module.exports = __webpack_public_path__ + "img/edc_pic_1.e95d8816.jpg";